<template>
  <div class="container">
    <div class="header">
      {{privacy.title}}
    </div>
    <div class="date">
      生效日期：{{privacy.date}}
    </div>
    <div class="text-main">
      <template v-for="(item, index) in privacy.content">
        <div class="desc" :key="`desc_${index}`">
          <p class="desc-title">{{`${index + 1}. ${item.title}`}}</p>
          <p class="desc-main" v-for="(descItem,descIndex) in item.desc" :key="`desc_${descIndex}`">{{ descItem }}</p>
        </div>
      </template>
    </div>
    <div class="footer">
      <pcFooter :code="true" :link="true" />
    </div>
  </div>
</template>

<script>
import pcFooter from '@/components/block/pcFooter'
import privacyJson from '@/assets/json/privacy.json'
export default {
  name: "Privacy",
  data() {
    return {
      privacy: privacyJson
    }
  },
  components: {
    pcFooter
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  //height: calc(100vh - 56px);
  padding: 80px 200px;
  box-sizing: border-box;
  color: #333;
  .header {
    width: 100%;
    text-align: center;
    font-size: 38px;
    font-weight: 500;
  }
  .date {
    width: 100%;
    height: 80px;
    line-height: 80px;
    border-bottom: 1px solid #c4c2cb;
    font-weight: 700;
  }
  .text-main {
    width: 100%;
    height: auto;
    //margin-top: 30px;
    margin: 30px 0 100px;
    .desc {
      .desc-title {
        font-size: 24px;
        //margin-top: 20px;
        margin: 20px 0;
        //text-indent:32px;
        line-height: 22px;
      }
      .desc-main {
        text-indent:32px;
        line-height: 22px;
      }
    }
  }
}
</style>